export const CHAT_MESSAGE_THRESHOLD_MIN = 10;
export const CHAT_MESSAGE_THRESHOLD_MAX = 2000;
/**
 * Higher CCV → shorter interval (more frequent). Min 20, max 60.
 */
export const calculateChatShareInterval = (ccv) => {
    if (ccv <= 0)
        return 60;
    return Math.max(20, Math.round(60 - 40 * Math.log10(ccv) / Math.log10(500)));
};
